<!--
* @Name：供应商付款查看明细
* @Author: 刘玉
* @Date: 2021-12-02 16:13:46
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 16:13:46
-->
<template>
  <div class="component-overlay">
    <van-nav-bar title="查看明细" left-arrow left-text="关闭" @click-left="onClickLeft" :fixed="true" />
    <div class="component-container">
      <hi-card v-for="(item, index) in detailsData" :key="item.poNo" :row-index="index + 1">
        <van-row>
          <span>采购订单号：</span>
          <span>{{ item.purOrderCode }}</span>
        </van-row>
        <van-row>
          <span>付款方式：</span>
          <span>{{ item.payCondDict | dictFilter(payTermOptions) }}</span>
        </van-row>
        <van-row>
          <span>单据类型：</span>
          <span>{{ item.poTypeDict | dictFilter(poTypeOptions) }}</span>
        </van-row>
        <van-row>
          <span>实际申请付款金额：</span>
          <span>{{ item.actualPayAmount }}</span>
        </van-row>
        <van-row>
          <span>下单日期：</span>
          <span>{{ item.poDate }}</span>
        </van-row>
      </hi-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewDetails',
  data() {
    return {}
  },
  props: {
    detailsData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    payTermOptions() {
      return this.$store.getters.dicts.pay_term
    },
    poTypeOptions() {
      return this.$store.getters.dicts.po_type
    }
  },
  methods: {
    onClickLeft() {
      this.$emit('close')
    }
  }
}
</script>
